import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useNavigate } from 'react-router-dom'
import { Funcionario, funcionario as api } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

interface IProps {
    open: boolean
    onClose: () => void
    funcionario: Funcionario
}

export function ExcluirFuncionario({ onClose, open, funcionario }: IProps) {
    const navigate = useNavigate()
    const empresaId = useStore(state => state.companyId)
    const setFuncionarioId = useStore(state => state.setEmployeeId)

    const { mutateAsync, isLoading } = api.mutations.useSoftDelete({
        queryParams: {
            empresaId,
        },
        invalidateQuery: true,
    })

    function handleSubmit() {
        return mutateAsync(funcionario, {
            onSuccess: () => {
                toast.success('Funcionario removido com sucesso!')
                setFuncionarioId(-1)
                navigate('/cadastros/funcionarios')
            },

            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            open={hasPermission(['delete', 'Funcionários']) && open}
            width="auto"
            height="auto"
            onClose={onClose}
            onSubmit={handleSubmit}
            loading={isLoading}
        >
            <Dialog.Content>
                Você tem certeza que deseja excluir {funcionario?.nome}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
